import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getDayWiseProgramDetailsUrl, insertUpdateDayWiseProgramUrl, GET_DAY_WISE_PROGRAMM_DETAILS,INSERT_UPDATE_DAY_WISE_PROGRAMM, headers } from "../../../utils/constants";

export const insertUpdateDayWiseProgram_action = (List) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            List: List
        }

        const res = await axiosPost(insertUpdateDayWiseProgramUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DAY_WISE_PROGRAMM,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const getDayWiseProgramDetails_action = (GateName) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            GateName: GateName !='' ?GateName:null 
        }

        const res = await axiosGet(getDayWiseProgramDetailsUrl, params, headers)

        dispatch({
            type: GET_DAY_WISE_PROGRAMM_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}